import { render, staticRenderFns } from "./TvaSocialSharing.vue?vue&type=template&id=22ac674a&scoped=true&"
import script from "./TvaSocialSharing.vue?vue&type=script&lang=js&"
export * from "./TvaSocialSharing.vue?vue&type=script&lang=js&"
import style0 from "./TvaSocialSharing.vue?vue&type=style&index=0&id=22ac674a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac674a",
  null
  
)

export default component.exports